<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Vagalumes</h1>
          </div>
          <!-- <h3 style="color:#888888" class="subtitle">{{ getClientName() }}</h3> -->
        </div>
        <div class="level-right" id="topTable">
          <div class="level-item">
            <b-button
              @click="modalOpen"
              v-if="isROOT"
              icon-right="plus"
              type="is-primary"
              >Adicionar</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="card has-table">
      <div class="card-header"></div>

      <b-table
        :data="desserts"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
        striped
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Nome" sortable>
            {{
              props.row.name
            }}
          </b-table-column>

          <b-table-column field="is_online" label="Status" sortable>
            <span
              v-if="props.row.historico"
              :class="['tag', props.row.is_online ? 'is-success' : 'is-danger']"
            >
              {{ props.row.historico[0].status }}</span
            >
          </b-table-column>
          <b-table-column field="ip" label="Endereço IP" sortable>
            {{ props.row.ip }}
          </b-table-column>
          <b-table-column
            field="total_connected"
            label="Nº Conectados"
            sortable
          >
            {{
              props.row.historico && props.row.historico[0].status == "online"
                ? props.row.total_connected
                : "offline"
            }}
          </b-table-column>
          <b-table-column label="Ativo desde" field="uptime" sortable>
            {{
              props.row.historico && props.row.historico[0].status == "online"
                ? new Date(props.row.uptime).toLocaleDateString("pt-BR") +
                  " " +
                  new Date(props.row.uptime).toLocaleTimeString("pt-BR")
                : ""
            }}
          </b-table-column>
          <b-table-column field="actions" label v-if="isROOT">
            <b-button
              icon-right="edit"
              size="is-small"
              type="is-light"
              @click="editItem(props.row)"
              >Editar</b-button
            >

            <b-button
              icon-right="trash"
              size="is-small"
              type="is-danger"
              @click="deleteItem(props.row)"
              >Excluir</b-button
            >
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem Vagalumes para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div class="columns">
      <div class="column is-one-quarters is-14-mobile ">
        <b-modal :active.sync="openModal" :can-cancel="true">
          <div class="card">
            <header class="modal-card-head">
              <div class="card-header-title">
                {{ formTitle }}
              </div>
            </header>

            <section class="modal-card-body">
              <div class="columns">
                <div class="column">
                  <div class="topFieldsModal">
                    <div class="column is-8">
                      <b-field label="Name" :label-position="labelPosition">
                        <b-input
                          type="text"
                          v-model="vagalume.name"
                          required
                        ></b-input>
                      </b-field>
                    </div>

                    <div class="column is-4">
                      <b-field label="MAC" :label-position="labelPosition">
                        <b-input
                          type="text"
                          v-cleave="masks.mac"
                          v-model="vagalume.mac"
                          required
                        ></b-input>
                      </b-field>
                    </div>
                  </div>
                  <div class="ips">
                    <div class="column is-half">
                      <b-field label="IP" :label-position="labelPosition">
                        <b-input
                          type="text"
                          v-model="vagalume.ip"
                          required
                        ></b-input>
                      </b-field>
                    </div>
                    <div class="column is-half">
                      <b-field
                        label="IP de Gestão"
                        :label-position="labelPosition"
                      >
                        <b-input
                          type="text"
                          v-model="vagalume.ipManagement"
                          required
                        ></b-input>
                      </b-field>
                    </div>
                  </div>
                  <div class="column is-full">
                    <div class="card">
                      <div class="fieldsMaps">
                        <div class="column is-1" id="titleBox">
                          <h2 class="is-size-9" align="left">
                            <b>Mapa</b>
                          </h2>
                        </div>

                        <div class="column is-3">
                          <b-field
                            label="Coordenada X"
                            :label-position="labelPosition"
                          >
                            <b-input v-model="vagalume.map.x"></b-input>
                          </b-field>
                        </div>
                        <div class="column is-3">
                          <b-field
                            label="Coordenada Y"
                            :label-position="labelPosition"
                          >
                            <b-input v-model="vagalume.map.y"></b-input>
                          </b-field>
                        </div>
                        <div class="column is-2">
                          <b-field label="Piso" :label-position="labelPosition">
                            <b-select
                              placeholder="Select a name"
                              v-model="vagalume.map.floor"
                            >
                              <option
                                v-for="floor in floors"
                                :value="floor"
                                :key="floor"
                              >
                                {{ floor }}
                              </option>
                            </b-select>
                          </b-field>
                        </div>

                        <div class="column is-2">
                          <b-field
                            label="Areas"
                            :label-position="labelPosition"
                          >
                            <b-select
                              placeholder="Select a areas"
                              v-model="vagalume.map.area"
                            >
                              <option
                                v-for="area in areas"
                                :value="area"
                                :key="area"
                              >
                                {{ area }}
                              </option>
                            </b-select>
                          </b-field>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="column is-full">
                    <div class="buttonAddInterface">
                      <div class="column is-narrow">
                        <b-button
                          icon-right="plus"
                          type="is-success"
                          @click="addInterface0"
                          >Add Iface wlan 0</b-button
                        >
                      </div>
                      <div class="column is-narrow">
                        <b-button
                          icon-right="plus"
                          type="is-success"
                          @click="addInterface1"
                          >Add Iface wlan 1</b-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="column is-full">
                    <p class="alertInterfaces"></p>
                  </div>
                  <div class="column is-full  ">
                    <ul>
                      <li
                        v-for="item in vagalume.interfaces"
                        :value="item"
                        :key="item.key"
                      >
                        <div class="topFieldsInterface">
                          <div class="column is-8">
                            <b-field
                              label="SSID"
                              :label-position="labelPosition"
                            >
                              <b-input
                                type="text"
                                v-model="item.ssid"
                                required
                              ></b-input>
                            </b-field>
                          </div>
                          <div class="column is-4">
                            <b-field
                              label="MAC"
                              :label-position="labelPosition"
                            >
                              <b-input
                                v-cleave="masks.mac"
                                v-model="item.mac"
                              ></b-input>
                            </b-field>
                          </div>
                        </div>
                        <div class="bottonFieldsInterface">
                          <div class="column is-4">
                            <b-field
                              label="Name"
                              :label-position="labelPosition"
                            >
                              <b-input
                                type="text"
                                v-model="item.name"
                                required
                              ></b-input>
                            </b-field>
                          </div>
                          <div class="column is-2">
                            <b-field id="checkboxCaptive">
                              <b-checkbox v-model="item.captiveControl">
                                Captive</b-checkbox
                              >
                            </b-field>
                          </div>
                          <div class="column is-3 ">
                            <b-field
                              label="Captive"
                              :label-position="labelPosition"
                              v-if="item.captiveControl"
                            >
                              <b-input
                                type="text"
                                v-model="item.captive"
                                required
                              ></b-input>
                            </b-field>
                          </div>
                          <div class="column is-2 ">
                            <b-button
                              icon-right="trash"
                              type="is-danger"
                              @click="deleteInterface(item)"
                              >Excluir</b-button
                            >
                          </div>
                        </div>
                        <hr
                          style="height:2px;border-width:0;color:gray;background-color:#DCDCDC"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <b-button id="buttonClose" label="Cancelar" @click="closeModal" />
              <b-button
                id="buttonClose"
                type="is-primary"
                label="Salvar"
                @click="save"
              />
            </footer>
          </div>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import axios from "axios";
import sms_credentials from "../../static/sms_credentials.json";
import GenericalLine from "@/components/charts/GenericalLine";
import BoxStat from "@/components/charts/BoxStat";
var async = require("async");
var moment = require("moment");
import * as byte_converter from "byte-converter";
import Cleave from "cleave.js";
var FileSaver = require("file-saver");
const Json2csvParser = require("json2csv").Parser;

const ws = new Webservices();
const cleave = {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector("input");
    input._vCleave.destroy();
  }
};
export default {
  components: {
    GenericalLine,
    BoxStat
    //SensoredLine
  },
  directives: { cleave },
  data: () => ({
    activeMap: store.state.client.activeMap,
    openModal: false,
    dateSD: "",
    dateED: "",
    start_date: "",
    end_date: "",
    dateSD: "",
    dateED: "",
    dates: [],
    segdata: {
      devices: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8
      ],
      online: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8
      ]
    },
    floors: [],
    areas: [],
    vagalume: {
      name: "",
      ip: "",
      ipManagement: "",
      mac: "",
      interfaces: [],
      map: {
        x: 0,
        y: 0,
        floor: 0,
        area: 0
      }
    },
    settings: { periodo: 24, labels: ["Download", "Upload"] },
    settingsLatencia: { periodo: 24, labels: ["Latencia"] },
    perPage: 25,
    desserts: [],
    dialog: false,
    edited: false,
    quantifyInterface: 0,
    alertInterfaces: false,
    headers: [
      {
        text: "Nome",
        align: "left",
        value: "text",
        sortable: true
      },
      {
        text: "StatusAP",
        align: "left",
        sortable: true
      },
      {
        text: "Tipo",
        align: "left",
        value: "text",
        sortable: true
      },
      {
        text: "Validade",
        align: "left",
        value: "text"
      },
      {
        text: "Disponibilidade",
        value: "disponibilidade",
        sortable: true,
        align: "true"
      },
      {
        text: "Capacidade",
        value: "numDispositivos",
        sortable: true,
        align: "true"
      },
      {
        text: "Actions",
        align: "left",
        value: "name",
        sortable: false
      }
    ],
    labelPosition: "on-border",
    editedIndex: -1,
    editedItem: {
      qtd: 1,
      numDispositivos: 1,
      type: "",
      exhibitionType: 0,
      validade: 24,
      observacoes: "",
      dataCriacao: new Date(),
      cpf: null,
      dispositivos: [],
      format: "####-####"
    },
    defaultItem: {
      qtd: 1,
      numDispositivos: 1,
      type: "",
      exhibitionType: 0,
      validade: 24,
      observacoes: "",
      code: 0,
      dataCriacao: new Date(),
      cpf: null,
      dispositivos: [],
      format: "####-####"
    },
    masks: {
      creditCard: { creditCard: true },
      ip: {
        numericOnly: true,
        delimiters: ["."]
      },
      mac: {
        delimiters: [":", ":", ":", ":", ":"],
        blocks: [2, 2, 2, 2, 2, 2],
        numericOnly: false,
        uppercase: true
      }
    }
  }),
  computed: {
    ...mapGetters([
      "getRules",
      "getClientID",
      "getID",
      "getRadioPrefix",
      "getToken",
      "isROOT"
    ]),
    formTitle() {
      return this.editedIndex == -1 ? "Novo Radios" : "Editar Radios";
    },
    isEdited() {
      return this.editedIndex != -1;
    },
    formOkLabel() {
      return this.editedIndex == -1 ? "Criar" : "Atualizar";
    }
  },

  async mounted() {
    ws.setToken(this.getToken);
    this.getAreas();
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    this.getFloors();
    ws.getRadiosByRadioPrefix("tsloja")
      .then(res => {
        let index = 1;
        res.data.forEach(element => {
          element.name = `AP${index}`;
          index++;
        });
        this.desserts = res.data;
        console.log(this.desserts);

        this.correctRadioModel();
      })
      .catch(err => {
        console.log(err);
      });
    this.dates = [
      moment()
        .subtract(6, "d")
        .toDate(),
      moment().toDate()
    ];
  },

  watch: {
    getRadioPrefix(newValue) {
      this.desserts = [];
      this.getAreas();

      this.vagalume = {
        clientname: store.state.client.controller_id,
        name: "",
        ip: "",
        ipManagement: "",
        mac: "",
        interfaces: [],
        map: {
          x: 0,
          y: 0,
          floor: 0
        }
      };
      //TODO quando troca de cliente na aba radio, a busca esta sendo feita pelo nome do cliente e nao pelo prefixo
      (this.activeMap = store.state.client.activeMap),
        ws.getRadiosByRadioPrefix(newValue).then(res => {
          this.desserts = res.data;
          this.correctRadioModel();
        });
      this.getFloors();
    }
  },

  created() {
    //this.initialize();
  },

  methods: {
    ...mapActions(["logout"]),
    onInput(event) {
      this.rawValue = event.target._vCleave.getRawValue();
      this.value = event.target._vCleave.getFormattedValue();
    },
    dateConverter(date) {
      if (date[0]) {
        return (
          date[0].toLocaleString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
          }) +
          " - " +
          date[1].toLocaleString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
          })
        );
      }
    },
    selectData() {
      this.dateSD = moment(this.dates[0]);
      this.dateED = moment(this.dates[1]);
    },
    closeModal() {
      this.openModal = false;
      this.edited = false;
      this.vagalume = {
        clientname: store.state.client.controller_id,
        name: "",
        ip: "",
        ipManagement: "",
        mac: "",
        interfaces: [],
        map: {
          x: 0,
          y: 0,
          floor: 0,
          areas: 0
        }
      };
      this.areas = [];
    },
    modalOpen() {
      this.vagalume.name = this.getRadioPrefix + "--";
      this.openModal = true;
      this.edited = false;
    },
    addInterface0() {
      this.quantifyInterface = this.vagalume.interfaces.length + 1;
      if (this.edited) {
      }

      var newInterface = {
        name: "wlan0-",
        ssid: "",
        mac: "",
        captiveControl: false,
        captive: store.state.client.controller_id
      };
      if (this.vagalume.interfaces.length < 8) {
        this.vagalume.interfaces.push(newInterface);
      }
    },
    addInterface1() {
      this.quantifyInterface = this.vagalume.interfaces.length + 1;
      var newInterface = {
        name: "wlan1-",
        ssid: "",
        mac: "",
        captiveControl: false,
        captive: store.state.client.controller_id
      };
      if (this.vagalume.interfaces.length < 8) {
        this.vagalume.interfaces.push(newInterface);
      } else {
        this.alertInterfaces = true;
      }
    },
    deleteInterface(item) {
      this.vagalume.interfaces.forEach((el, index) => {
        if (el.name == item.name) {
          this.vagalume.interfaces.splice(index, 1);
        }
      });
    },

    getFloors() {
      if (store.state.client.Floors) {
        Object.keys(store.state.client.Floors).forEach(key => {
          this.floors[key] = key;
        });
      }
    },
    async getAreas() {
      if (store.state.client.id) {
        let areasClient = await ws.getAreaClientById(store.state.client.id);
        console.log(areasClient);
        for (let aux = 1; aux <= areasClient.data[0].areas; aux++) {
          this.areas[aux - 1] = aux;
        }
        console.log(this.areas);
      }
    },

    getBitrateConvert(bitrate) {
      var converter = byte_converter.converterBase2;
      if (bitrate < 1024) {
        return bitrate.toFixed(0) + " bit/s";
      } else if (bitrate >= 1024 && bitrate < 1048576) {
        return (
          Number.parseInt(converter(bitrate, "B", "KB")).toFixed(0) + " Kbps"
        );
      } else if (bitrate >= 1048576 && bitrate <= 1073741824) {
        return (
          Number.parseInt(converter(bitrate, "B", "MB")).toFixed(2) + " Mbps"
        );
      } else {
        return (
          Number.parseInt(converter(bitrate, "B", "GB")).toFixed(2) + " Gbps"
        );
      }
    },
    getOnlyBitrateConvert(bitrate) {
      var converter = byte_converter.converterBase2;
      if (bitrate < 1024) {
        return bitrate.toFixed(0);
      } else if (bitrate >= 1024 && bitrate < 1048576) {
        return Number.parseInt(converter(bitrate, "B", "KB")).toFixed(2);
      } else if (bitrate >= 1048576 && bitrate <= 1073741824) {
        return Number.parseInt(converter(bitrate, "B", "MB")).toFixed(2);
      } else {
        return Number.parseInt(converter(bitrate, "B", "GB")).toFixed(2);
      }
    },
    getClientName() {
      if (store.state && store.state.client) {
        return store.state.client.name;
      } else {
        return "";
      }
    },
    getClientLink() {
      if (store.state && store.state.client) {
        return store.state.client.link;
      } else {
        return false;
      }
    },
    getClientLinkInterfaces() {
      if (store.state && store.state.client) {
        return store.state.client.link_config;
      }
    },
    // sendSms(radios) {
    //     //procurar nos Vouchers
    // },
    correctRadioModel() {
      var i = 0;
      for (i = 0; i < this.desserts.length; i++) {
        if (
          this.desserts &&
          this.desserts[i].historico &&
          !!this.desserts[i].historico[0]
        ) {
          if (this.desserts[i].historico[0].status == "online") {
            this.desserts[i]["uptime"] = this.desserts[i].historico[0].date;
            this.desserts[i]["is_online"] = true;
          } else {
            this.desserts[i]["uptime"] = 0;
            this.desserts[i]["is_online"] = false;
          }
        } else {
          this.desserts[i]["uptime"] = 0;
          this.desserts[i]["is_online"] = false;
        }

        this.desserts[i]["total_connected"] = this.desserts[i].total5ghz
          ? this.desserts[i].total5ghz + this.desserts[i].total2ghz
          : this.desserts[i].total2ghz
          ? this.desserts[i].total2ghz
          : 0;
      }
    },
    closeLink() {
      this.dialogLink = false;
    },
    editItem(item) {
      this.openModal = true;
      this.edited = true;

      this.vagalume = item;
      if (!item.ipManagement || item.ipManagement == "") {
        item.ipManagement = item.ip;
      }

      item.interfaces.forEach(iface => {
        if (iface.captive == "ACTIVE" || iface.captive == "ATIVO") {
          iface.captiveControl = true;
          iface.captive = store.state.client.controller_id;
        }
      });
    },
    async deleteItem(item) {
      await ws.deleteRadiosbyRadioPrefix(item.id);
      this.desserts.forEach((el, index) => {
        if (el.id == item.id) {
          this.desserts.splice(index, 1);
        }
      });
    },
    async save() {
      var correctMap = false;
      if (store.state.client.activeMap) {
        Object.keys(store.state.client.Floors).forEach(key => {
          if (key == this.vagalume.map.floor) {
            if (
              this.vagalume.map.x < store.state.client.Floors[key].Width &&
              this.vagalume.map.y < store.state.client.Floors[key].Height
            ) {
              correctMap = true;
            }
          }
        });
      } else {
        correctMap = true;
      }
      if (
        this.vagalume.name &&
        this.vagalume.ip &&
        this.vagalume.mac &&
        this.vagalume.ipManagement &&
        correctMap
      ) {
        this.openModal = false;
        this.vagalume.interfaces.forEach((el, index) => {
          if (!el.captiveControl) {
            this.vagalume.interfaces[index].captive = "INATIVO";
          }
          delete this.vagalume.interfaces[index].captiveControl;
        });

        var saveVagalume = {
          vagalumes: []
        };

        saveVagalume.vagalumes[0] = this.vagalume;
        if (this.edited) {
          await ws.patchRadiosbyRadioPrefix(this.vagalume);
        } else {
          await ws.postRadiosbyRadioPrefix(saveVagalume);
        }
        this.edited = false;
        this.vagalume = {
          clientname: store.state.client.controller_id,
          name: "",
          ip: "",
          ipManagement: "",
          mac: "",
          interfaces: [],
          map: {
            x: 0,
            y: 0,
            floor: 0
          }
        };
      } else {
        if (correctMap) {
          alert("preencha os campos Obrigatórios");
        } else {
          alert(
            "As coordenadas do Vagalume precisam estar de acordo com os limites do piso"
          );
        }
      }
    }
  }
};
</script>

<style scoped>
.modal .animation-content .modal-card {
  height: 700px !important;
  width: 1000px !important;
}

.capitalize {
  text-transform: capitalize !important;
}

#topTable {
  padding-bottom: 10px;
}
.ips {
  display: flex;
}
.topFieldsModal {
  display: flex;
}
.fieldsMaps {
  display: flex;
}
.addInterface {
  display: flex;
}
.topFieldsInterface {
  display: flex;
}
.bottonFieldsInterface {
  display: flex;
}
.interfaces {
  display: flex;
}
.alertInterfaces {
  font-size: 10px;
  color: red;
}
.buttonAddInterface {
  display: flex;
}
#checkboxCaptive {
  padding-top: 7px;
}
#titleBox {
  padding-top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Radios.vue